import { render, staticRenderFns } from "./TxMsg.vue?vue&type=template&id=ae5b1dda"
import script from "./TxMsg.vue?vue&type=script&lang=js"
export * from "./TxMsg.vue?vue&type=script&lang=js"
import style0 from "./TxMsg.vue?vue&type=style&index=0&id=ae5b1dda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports